import {Component, OnInit} from '@angular/core';
import {FilterModel} from '../../../entities/FilterModel';
import {AppTaskCategory} from '../../../entities/AppTaskCategory';
import {MaintenanceObject_DTO} from '../../../entities/MaintenanceObject_DTO';
import {Responsible} from '../../../entities/SalesPerson';
import {NotificationService} from '../../../services/notification.service';
import {LoginService} from '../../../services/login.service';
import {TaskService} from '../../../services/task.service';
import {TaskActivityService} from '../../../services/task-activity.service';
import {MaintenanceObjectService} from '../../../services/maintenance-object.service';
import {SalesPersonService} from '../../../services/sales-person.service';
import {Task} from '../../../entities/Task';
import {TaskActivity} from '../../../entities/TaskActivity';
import {SessionService} from '../../../services/session.service';
import {DatePickerModel} from '../../../entities/DatePickerModel';
import * as moment from 'moment';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-task-overview',
  templateUrl: './task-overview.component.html',
  styleUrls: ['./task-overview.component.css']
})
export class TaskOverviewComponent implements OnInit {

  public notifications: any[] = [];
  public loggedInUserNo: string;
  public lastUsedFilterModel: FilterModel;
  public navigationDate: Date;
  datePickerModel: DatePickerModel = {}
  tasks: Task[];
  public appTaskCategories: AppTaskCategory[];
  public maintenanceObjectDTO: MaintenanceObject_DTO;
  public salespersons: Responsible[];
  public companies: any[];

  constructor(private notificationService: NotificationService,
              private loginService: LoginService,
              private taskService: TaskService,
              private activityService: TaskActivityService,
              private maintenanceObjectService: MaintenanceObjectService,
              private salesPersonService: SalesPersonService,
              private sessionService: SessionService) {
  }

  ngOnInit() {
    this.loggedInUserNo = this.loginService.getLoggedInUserID();
    this.navigationDate = new Date();
    this.initInitialData();
    this.initDateNavigation(new Date());
  }

  GetTasks(filterModel: FilterModel = null) {
    if (filterModel != null) {
      this.lastUsedFilterModel = filterModel;
    }
    this.taskService.getMaintenanceTasks(this.lastUsedFilterModel).subscribe(result => {        
      this.tasks = [...result];
    });
  }

  CreateNotification(notification: any) {
    notification.Responsible_Company = this.sessionService.getSelectedCompany();
    this.notificationService.Post(notification).subscribe(x => {
      this.GetTasks();
    });
  }

  // Calls the service to save the updated task data, after converting the dateTime.
  updateTask(taskToUpdate: Task) {
    this.taskService.putTaskInfo(taskToUpdate).subscribe(resp => {
      this.GetTasks();
    });
  }

  updateTaskActivities(taskActivities: TaskActivity[]) {
    this.activityService.putTaskActivities(taskActivities).subscribe(resp => {
      this.GetTasks();
    });
  }

  setOptionsData() {
    this.datePickerModel.dummyStart = {date: {year: this.datePickerModel.StartDate.getFullYear(), month: this.datePickerModel.StartDate.getMonth() + 1, day: this.datePickerModel.StartDate.getDate()}};
    this.datePickerModel.dummyEnd = {date: {year: this.datePickerModel.EndDate.getFullYear(), month: this.datePickerModel.EndDate.getMonth() + 1, day: this.datePickerModel.EndDate.getDate()}};

    this.datePickerModel.startDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{begin: this.datePickerModel.dummyEnd.date, end: {year: 2055, month: 11, day: 20}}],
    };
    this.datePickerModel.endDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{begin: {year: 1980, month: 11, day: 20}, end: this.datePickerModel.dummyStart.date}],
    };
  }

  private initDateNavigation(defaultDate: Date) {
    const d = new Date(defaultDate);

    const startDate = new Date(d.setDate(d.getDate()));

    this.datePickerModel.StartDate = new Date(startDate);
    this.datePickerModel.StartDate.setHours(0);
    this.datePickerModel.StartDate.setMinutes(0);
    this.datePickerModel.StartDate.setSeconds(0);

    const diff2 = startDate.getDate() + 6;
    this.datePickerModel.EndDate = new Date(startDate.setDate(diff2));
    this.datePickerModel.EndDate.setHours(0);
    this.datePickerModel.EndDate.setMinutes(0);
    this.datePickerModel.EndDate.setSeconds(0);

    this.setOptionsData();

    // Maintenance
    this.GetTasks(new FilterModel(moment(this.datePickerModel.StartDate).format(environment.FULL_DATETIME_FORMAT), moment(this.datePickerModel.EndDate).format(environment.FULL_DATETIME_FORMAT)));
  }


  private initInitialData() {
    this.notificationService.GetTaskCategories().subscribe(x => {
      this.appTaskCategories = x;
    });
    this.maintenanceObjectService.Get(null, null, true, true).subscribe(x => {
      this.maintenanceObjectDTO = x;
    });
    const salesPersonSub = this.salesPersonService.getAllSalesPersonsAsSalesPerson().subscribe(result => {
      if (result.length > 0) {
        this.salespersons = result;
      }
    }, error => {}, () => {salesPersonSub.unsubscribe()});

    const loginSub = this.loginService.getCompanies().subscribe(companies => {
      this.companies = companies;
    }, error => {}, () => {loginSub.unsubscribe()})
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/notification-overview/task-overview/task-overview.component.ts